import React, { useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import EditBar from "components/EditBar";
import { AddOnContainer, Row } from "./styles";

const AddOns = ({
  breakfastQuantity,
  setBreakfastQuantity,
  breakfastLength,
  setBreakfastLength,
  breakfastUnitPrice,
  parkingQuantity,
  setParkingQuantity,
  parkingLength,
  setParkingLength,
  parkingUnitPrice,
  checkInDate,
  checkOutDate,
}) => {

  return (
    <Card>
      <CardHeader>
        <div className="cardTitle">ADD-ONS</div>
      </CardHeader>
      <AddOnContainer>
        <Row>
          <EditBar
            value={breakfastQuantity}
            setValue={setBreakfastQuantity}
            length={breakfastLength}
            setLength={setBreakfastLength}
            unit={"Person"}
            checkInDate={checkInDate}
            checkOutDate={checkOutDate}
            pluralUnit={"People"}
            unitPrice={breakfastUnitPrice?.toFixed(2)}
            title="BREAKFAST"
          />
        </Row>
        <Row>
          <EditBar
            value={parkingQuantity}
            setValue={setParkingQuantity}
            length={parkingLength}
            setLength={setParkingLength}
            unit={"Car"}
            checkInDate={checkInDate}
            checkOutDate={checkOutDate}
            pluralUnit={"Cars"}
            unitPrice={parkingUnitPrice?.toFixed(2)}
            title="PARKING"
          />
        </Row>
      </AddOnContainer>
    </Card>
  );
};

export default AddOns;
